// rsvp.js

const BIN_ID = "688c88e67b4b8670d8aae034"; // 교체 필요
const MASTER_KEY = "$2a$10$/OYcsnUuFM0JL31lkKjxi.Oywdoh0Q8NQlCnxaHz6niOs8e.BJgPi";
const ACCESS_KEY = "$2a$10$ZOccfsCeb7O4id0nKAqCxOH3DK5KSqndPEAlKP4wbhtrjV6GVX/9y";

document.addEventListener("DOMContentLoaded", () => {
  const box = document.getElementById("going-box");
  if (!box) return;

  const articleId = box.dataset.articleId;
  const title = box.dataset.title;
  const localKey = `going-${articleId}`;

  const goingWrapper = box.querySelector(".going-wrapper");
  const goingButton = box.querySelector("#going-button");
  const goingButtonLabel = goingButton.querySelector(".label");
  const notGoingButton = box.querySelector(".not-going-button");

  const modal = document.getElementById("rsvp-modal");
  const modalOverlay = modal.querySelector(".rsvp-modal__overlay");
  const form = document.getElementById("rsvp-form");
  const nameInput = document.getElementById("rsvp-name");
  const emailInput = document.getElementById("rsvp-email");
  const phoneInput = document.getElementById("rsvp-phone");
  const cancelBtn = document.getElementById("rsvp-cancel");
  const submitBtn = document.getElementById("rsvp-submit");

  function openModal() {
    modal.style.display = "flex";
  }

  function closeModal() {
    modal.style.display = "none";
    form.reset();
    submitBtn.disabled = false;
  }

  function setGoingUI() {
    goingButtonLabel.textContent = "You’re on the List";
    goingWrapper.setAttribute("data-going", "true");
  }

  function setNotGoingUI() {
    goingButtonLabel.textContent = "Count Me In";
    goingWrapper.setAttribute("data-going", "false");
    goingWrapper.removeAttribute("open");
  }

  async function fetchLatest() {
    const res = await fetch(`https://api.jsonbin.io/v3/b/${BIN_ID}`, {
      headers: { "X-Master-Key": MASTER_KEY },
    });
    if (!res.ok) throw new Error("Fetch failed");
    return res.json();
  }

  async function putRecord(data) {
    const res = await fetch(`https://api.jsonbin.io/v3/b/${BIN_ID}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Key": ACCESS_KEY,
      },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error("PUT failed");
    return res.json();
  }

  async function addAttendee({ name, email, phone }) {
    const data = await fetchLatest();
    if (!data.record.articles) data.record.articles = {};
    if (!data.record.articles[articleId]) {
      data.record.articles[articleId] = {
        title,
        count: 0,
        attendees: [],
      };
    }

    const entry = data.record.articles[articleId];
    const emailKey = email.trim().toLowerCase();
    const idx = entry.attendees.findIndex((p) => (p.email || "").toLowerCase() === emailKey);

    if (idx === -1) {
      entry.attendees.push({ name, email, phone, timestamp: new Date().toISOString() });
      entry.count = entry.attendees.length;
    } else {
      entry.attendees[idx].name = name;
      entry.attendees[idx].phone = phone;
    }

    await putRecord(data.record);

    localStorage.setItem(localKey, JSON.stringify({ going: true, name, email, phone }));
    setGoingUI();
    closeModal();
  }

  async function removeAttendeeByEmail(email) {
    setNotGoingUI(); // 🔄 빠르게 UI 반영

    const data = await fetchLatest();
    const entry = data.record.articles?.[articleId];
    if (!entry) return;

    const emailKey = email.trim().toLowerCase();
    entry.attendees = entry.attendees.filter((p) => (p.email || "").toLowerCase() !== emailKey);
    entry.count = entry.attendees.length;

    await putRecord(data.record);

    localStorage.removeItem(localKey);
  }

  goingButton.addEventListener("click", (e) => {
    e.preventDefault();
    const stored = localStorage.getItem(localKey);
    const isGoing = stored && JSON.parse(stored).going;
    const isOpen = goingWrapper.hasAttribute("open");

    if (!isGoing) openModal();
    else goingWrapper.toggleAttribute("open", !isOpen);
  });

  notGoingButton.addEventListener("click", async () => {
    const stored = localStorage.getItem(localKey);
    if (!stored) return setNotGoingUI();
    const { email } = JSON.parse(stored);
    if (!email) return setNotGoingUI();

    try {
      await removeAttendeeByEmail(email);
    } catch (err) {
      console.error("Cancel failed:", err);
    }
  });

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const name = nameInput.value.trim();
    const email = emailInput.value.trim();
    const phone = phoneInput.value.trim();
    if (!name || !email) return;

    submitBtn.disabled = true;

    try {
      await addAttendee({ name, email, phone });
    } catch (err) {
      console.error("Submit failed", err);
      submitBtn.disabled = false;
    }
  });

  cancelBtn.addEventListener("click", closeModal);
  modalOverlay.addEventListener("click", closeModal);

  try {
    const stored = localStorage.getItem(localKey);
    const isGoing = stored && JSON.parse(stored).going;
    isGoing ? setGoingUI() : setNotGoingUI();
  } catch {
    setNotGoingUI();
  }
});
